import {
  KEYCLOAK_DEBUG,
  LOGIN_REDIRECT_URI,
  SILENT_CHECK_SSO_FILE,
} from "../constants/environment";
import {
  AuthClientInitOptions,
  AuthClientTokens,
} from "@react-keycloak/core/lib/types";

const keycloakInitOptions = (
  appToken: AuthClientTokens | undefined
): AuthClientInitOptions => {
  return {
    silentCheckSsoRedirectUri: `${LOGIN_REDIRECT_URI}${SILENT_CHECK_SSO_FILE}`,
    ...appToken,
    enableLogging: KEYCLOAK_DEBUG,
    pkceMethod: "S256",
  };
};
export { keycloakInitOptions };
